module.exports = __webpack_public_path__ + "static/media/bulbguardcam-5.2af55f15.jpg";